// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.direction-container{
    width: 400px;
    height: 400px;
    display:flex;
    position: relative;
}

.direction-background{
    width: 100%;
    height: 100%;
}

.direction-container h4{
    color: #FFBD59;
    font-size: 30px;
    text-shadow: 0px 0px 2px black;
    position:absolute;
}

.direction-good{
    color: #09ff00 !important;
}

.direction-one{
    top: 9%;
    left: 53%;
}

.direction-two{
    top: 23%;
    left: 79%;
}

.direction-three{
    top: 52%;
    left: 85%;
}

.direction-four{
    top: 75%;
    left: 70%;
}

.direction-five{
    top: 82%;
    left: 44%;
}

.direction-six{
    top: 68%;
    left: 19%;
}

.direction-seven{
    top: 40%;
    left: 10%;
}

.direction-eight{
    top: 15%;
    left: 25%;
}

@media screen and (max-width: 540px) {
    .direction-container{
        width: 100%;
        height: 400px;
        display:flex;
        position: relative;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DirectionSection.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,YAAY;QACZ,kBAAkB;IACtB;AACJ","sourcesContent":[".direction-container{\n    width: 400px;\n    height: 400px;\n    display:flex;\n    position: relative;\n}\n\n.direction-background{\n    width: 100%;\n    height: 100%;\n}\n\n.direction-container h4{\n    color: #FFBD59;\n    font-size: 30px;\n    text-shadow: 0px 0px 2px black;\n    position:absolute;\n}\n\n.direction-good{\n    color: #09ff00 !important;\n}\n\n.direction-one{\n    top: 9%;\n    left: 53%;\n}\n\n.direction-two{\n    top: 23%;\n    left: 79%;\n}\n\n.direction-three{\n    top: 52%;\n    left: 85%;\n}\n\n.direction-four{\n    top: 75%;\n    left: 70%;\n}\n\n.direction-five{\n    top: 82%;\n    left: 44%;\n}\n\n.direction-six{\n    top: 68%;\n    left: 19%;\n}\n\n.direction-seven{\n    top: 40%;\n    left: 10%;\n}\n\n.direction-eight{\n    top: 15%;\n    left: 25%;\n}\n\n@media screen and (max-width: 540px) {\n    .direction-container{\n        width: 100%;\n        height: 400px;\n        display:flex;\n        position: relative;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
